import { Routes, Route, Navigate } from 'react-router-dom'
import Layout from '../../components/Layout'
import InterviewerHome from './InterviewerHome'
import InterviewerClients from './InterviewerClients'
import InterviewerSessions from './InterviewerSessions'
import InterviewSession from './InterviewSession'
import InterviewerSchedule from './InterviewerSchedule'
import InterviewerNotes from './InterviewerNotes'
import InterviewerEvaluations from './InterviewerEvaluations'
import EvaluationDetail from './EvaluationDetail'
import InterviewerRecordings from './InterviewerRecordings'
import InterviewerReports from './InterviewerReports'
import InterviewerRatings from './InterviewerRatings'
import InterviewerSettings from './InterviewerSettings'

export default function InterviewerDashboard() {
  return (
    <Layout role="interviewer">
      <Routes>
        <Route index element={<Navigate to="home" replace />} />
        <Route path="home" element={<InterviewerHome />} />
        <Route path="clients" element={<InterviewerClients />} />
        <Route path="sessions" element={<InterviewerSessions />} />
        <Route path="sessions/:id" element={<InterviewSession />} />
        <Route path="bookings/:bookingId" element={<InterviewSession />} />
        <Route path="schedule" element={<InterviewerSchedule />} />
        <Route path="notes" element={<InterviewerNotes />} />
        <Route path="evaluations" element={<InterviewerEvaluations />} />
        <Route path="evaluations/:id" element={<EvaluationDetail />} />
        <Route path="recordings" element={<InterviewerRecordings />} />
        <Route path="reports" element={<InterviewerReports />} />
        <Route path="ratings" element={<InterviewerRatings />} />
        <Route path="settings" element={<InterviewerSettings />} />
      </Routes>
    </Layout>
  )
}
